<template>
<!-- 基本信息 -->
    <div class="user-info">
        <div class="info-ul">
            <div class="info-li">
                <div>{{$t('pages.user.text5')}}:</div>
                <div>{{currentUser.appAccount}}</div>
            </div>
            <div class="info-li">
                <div>{{$t('pages.user.text22')}}:</div>
                <div>{{currentUser.nickname}}</div>
            </div>
            <div class="info-li">
                <div>{{$t('pages.user.text4')}}:</div>
                <div>{{currentUser.createdAt}}</div>
            </div>
            <div class="info-li">
                <div>{{$t('pages.user.text3')}}:</div>
                <div v-if="currentUser.city">{{currentUser.city}}</div>
            </div>
        </div>
        <div class="user-hearder">
            <div><el-avatar :size="80" :src="currentUser.headImg?currentUser.headImg:circleUrl"></el-avatar></div>
            <div>{{$t('pages.user.text23')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            circleUrl:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
        }
    },
    props:['currentUser']
}
</script>


<style scoped>
.user-info{
    border: 1px solid #dfdfdf;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
}
.info-ul{
    flex: 1;
}
.info-li{
    display: flex;
    margin: 10px 0;
}
.info-li div:first-child{
    text-align: end;
    margin-right: 10px;
}
.user-hearder{
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.user-hearder div:first-child{
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.user-hearder div:last-child{
    margin-top: 10px;
    text-align: center;
}
</style>